export enum QuoteDocumentsMode {
  QUOTE = 'quote',
  SETTINGS = 'settings',
}

export const ITEM_TYPE = 'QUOTE_DOCUMENT_ROW';
export const MAX_FILE_SIZE_BYTES = 10 * 1000 * 1000;
export const ROW_GRID_TEMPLATE_COLUMNS =
  '16px minmax(180px, 1fr) minmax(180px, 1fr) minmax(90px, 1fr) 88px';
export const ROW_GRID_MIN_WIDTH = '640px';

// Settings has no Source column (every doc it manages is library-sourced by
// definition, so the tag was never informative there) — dropping it frees
// up room for the Add to New Quotes column while keeping the row narrower than
// Quote's template, which is what lets it fit the Settings accordion.
// Actions is narrower than Quote's 88px — Settings rows only ever show the
// Replace/Remove kebab there (no Download button), so there's no second
// icon to make room for.
export const SETTINGS_ROW_GRID_TEMPLATE_COLUMNS =
  '16px minmax(140px, 1fr) minmax(100px, 1fr) 200px 48px';
export const SETTINGS_ROW_GRID_MIN_WIDTH = '480px';
